import request from '@/http/request'
import wayCode from "@/utils/wayCode";
import channelUserIdUtil from "@/utils/channelUserId";
import config from '@/config'

/** 获取url **/
export function getRedirectUrl () {
  const payWay = wayCode.getPayWay();
  console.log('[API] 调用getRedirectUrl');
  console.log('[API] payWay:', payWay);
  console.log('[API] token:', config.cacheToken);
  
  if (!payWay || !payWay.wayCode) {
    console.error('[API] wayCode为空，无法调用redirectUrl');
    return Promise.reject({ msg: '无法获取支付方式，请在微信或支付宝内打开' });
  }
  
  return request.request({
    url: '/api/cashier/redirectUrl',
    method: 'POST',
    data: { wayCode: payWay.wayCode, token: config.cacheToken }
  }).then(res => {
    console.log('[API] getRedirectUrl返回:', res);
    return res;
  }).catch(err => {
    console.error('[API] getRedirectUrl失败:', err);
    throw err;
  })
}

/** 获取url **/
export function getChannelUserId (redirectData) {
  const payWay = wayCode.getPayWay();
  if (!payWay || !payWay.wayCode) {
    console.error('[API] wayCode为空，无法调用channelUserId');
    return Promise.reject({ msg: '无法获取支付方式' });
  }
  
  return request.request({
    url: '/api/cashier/channelUserId',
    method: 'POST',
    data: Object.assign({ wayCode: payWay.wayCode, token: config.cacheToken }, redirectData)
  })
}

/** 调起支付接口, 获取支付数据包 **/
export function getPayPackage (amount) {
  return request.request({
    url: '/api/cashier/pay',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay().wayCode,
      token: config.cacheToken,
      amount: amount,
      channelUserId: channelUserIdUtil.getChannelUserId()
    }
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfo () {
  return request.request({
    url: '/api/cashier/payOrderInfo',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay() ? wayCode.getPayWay().wayCode : '',
      token: config.cacheToken
    }
  })
}

/** 调起支付接口, 获取订单信息 **/
export function getPayOrderInfoState () {
  return request.request({
    url: '/api/cashier/getPayOrderState',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay() ? wayCode.getPayWay().wayCode : '',
      token: config.cacheToken
    }
  })
}

/** 更新代收订单客户信息（付款人姓名） **/
export function updateCustomerInfo (customerName) {
  return request.request({
    url: '/api/cashier/updateCustomerInfo',
    method: 'POST',
    data: {
      wayCode: wayCode.getPayWay() ? wayCode.getPayWay().wayCode : '',
      token: config.cacheToken,
      customerName: customerName
    }
  })
}

/** 取消订单 **/
export function cancelPay () {
  return request.request({
    url: '/api/cashier/cancelPay',
    method: 'POST',
    data: {
      token: config.cacheToken
    }
  })
}

/** 快捷支付申请短信验证码 **/
export function applyQuickPay (payload) {
  return request.request({
    url: '/api/cashier/quickPay/apply',
    method: 'POST',
    data: Object.assign({
      token: config.cacheToken
    }, payload)
  })
}

/** 快捷支付确认 **/
export function confirmQuickPay (payload) {
  return request.request({
    url: '/api/cashier/quickPay/confirm',
    method: 'POST',
    data: Object.assign({
      token: config.cacheToken
    }, payload)
  })
}
